import styled from 'styled-components';
import {
  BaseContainer,
  EventValue,
  LabelValuePairRow,
  TitleRow,
} from './TooltipUI';
import { sankeyChartColors } from '../utils/analysisColorConfig';
import { ISankeyLink } from './interfaces';
import {
  defaultNumberFormatOptions,
  globalFormat,
} from '../../../utils/formatting';
import { useFloatingLayerContext } from '../../FloatingManager';
import ThinDivider from '../../ThinDivider';
import { createPortal } from 'react-dom';
interface IProps {
  isBase: boolean;
  analysisId: string;
  tooltipLinkIndex: number;
  links: ISankeyLink[];
  left: number;
  top: number;
  isObserveMode: boolean;
}

const Container = styled(BaseContainer)`
  min-width: 200px;
  max-width: 258px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.15);
  border-radius: 8px;
`;
const CvrLabel = styled.div`
  font-weight: 500;
`;

export default ({ isBase, tooltipLinkIndex, links, left, top }: IProps) => {
  if (tooltipLinkIndex === -1 || (top === 0 && left === 0)) {
    return null;
  }

  const link = links[tooltipLinkIndex];
  const sourceColor =
    sankeyChartColors[link?.source?.colorIndex % sankeyChartColors.length];
  const targetColor =
    sankeyChartColors[link?.target?.colorIndex % sankeyChartColors.length];
  const sourceDisplay = link?.source?.name;
  const sourceGroupName = link?.source?.groupName;
  const targetDisplay = link?.target?.name;
  const sourceValue = link?.source?.value;
  const targetValue = link?.value;
  const cvr = globalFormat.formatNumber(
    targetValue / sourceValue,
    defaultNumberFormatOptions.percent,
  );

  const zIndex = useFloatingLayerContext();

  return createPortal(
    <Container
      onMouseOver={(event) => {
        event.stopPropagation();
        event.preventDefault();
      }}
      style={{ position: 'fixed', top, left, zIndex }}
    >
      {!isBase && (
        <>
          <TitleRow $color={sourceColor}>{sourceGroupName}</TitleRow>
          <ThinDivider layout="horizontal" size="full" />
        </>
      )}
      <LabelValuePairRow $borderColor={sourceColor}>
        <span>{sourceDisplay}</span>
        <EventValue>
          {globalFormat.formatNumber(
            sourceValue,
            defaultNumberFormatOptions.integer,
          )}
        </EventValue>
      </LabelValuePairRow>
      <LabelValuePairRow $borderColor={targetColor}>
        <span>{targetDisplay}</span>
        <EventValue>
          {globalFormat.formatNumber(
            targetValue,
            defaultNumberFormatOptions.integer,
          )}
        </EventValue>
      </LabelValuePairRow>
      <ThinDivider layout="horizontal" size="full" />
      <LabelValuePairRow>
        <CvrLabel>CVR</CvrLabel>
        <EventValue>{cvr}</EventValue>
      </LabelValuePairRow>
    </Container>,
    document.body,
  );
};
